import { Close } from "@mui/icons-material";
import { Button, IconButton, Modal, Paper, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { FormProvider, RHFTextField } from "../../../components/hook-form";
import { CLOSE_EDIT_BIO } from "../../../redux/types";
import { updateProfile } from "../../../redux/actions/profileActions";
import { useState } from "react";

const EditBio = () => {
  const { openBio: open } = useSelector((state) => state.ModalsControl);
  const [bio, setBio] = useState();

  const bioSchema = Yup.object().shape({
    bio: Yup.string(),
  });

  const defaultValues = {
    bio: "",

    // remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(bioSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;
  const dispatch = useDispatch();
  const onSubmit = (values) => {
    dispatch(updateProfile({ bio }));
    dispatch({ type: CLOSE_EDIT_BIO });
  };

  return (
    <Modal
      className="grid place-items-center "
      open={open}
      onClose={() => dispatch({ type: CLOSE_EDIT_BIO })}>
      <Paper elevation={8} className="!bg-slate-100 p-2 w-[90%] relative ">
        <IconButton
          className="absolute top-0 left-4"
          onClick={() => dispatch({ type: CLOSE_EDIT_BIO })}>
          <Close />
        </IconButton>

        <FormProvider
          methods={methods}
          classes=" shadow-lg border-slate-100 rounded-lg p-6 mt-4   bg-white grid place-items"
          onSubmit={handleSubmit(onSubmit)}>
          <p className=" w-full text-justify mb-2 ">
            share a bit about yourself
          </p>
          <div className="mb-4">
            <textarea
              name="bio"
              className="bg-slate-100 w-full h-[8rem] p-4 resize-none"
              placeholder="some interesting details about me"
              onChange={(e) => setBio(e.target.value)}></textarea>
          </div>
          <Button type="submit" variant="contained" className="!bg-rose-500">
            save
          </Button>
        </FormProvider>
      </Paper>
    </Modal>
  );
};

export default EditBio;
